import { render, staticRenderFns } from "./RecentUploadsList.vue?vue&type=template&id=c798bbf8&scoped=true&"
import script from "./RecentUploadsList.vue?vue&type=script&setup=true&lang=js&"
export * from "./RecentUploadsList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RecentUploadsList.vue?vue&type=style&index=0&id=c798bbf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c798bbf8",
  null
  
)

export default component.exports